// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import Link from '@deere/cps-it.warranty-model-factory/lib/link';
import UserPopover from './user-popover';

const Greeting = props =>
    <section className='greeting'>
        <span className='welcome'>
            <FormattedMessage id='WELCOME'/>
        </span>
        <UserPopover
            firstName={props.firstName}
            isSapUp={props.isSapUp}
            lastName={props.lastName}
            links={props.links}
        />
    </section>;

Greeting.displayName = 'Greeting';
Greeting.propTypes = {
    firstName: PropTypes.string.isRequired,
    isSapUp: PropTypes.bool.isRequired,
    lastName: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(PropTypes.instanceOf(Link)).isRequired
};

export default Greeting;



// WEBPACK FOOTER //
// ./src/app/greeting.js